export default __webpack_public_path__ + "static/media/Path671.7f596821.png";